<template>
    <div id="app">
        <transition name="fade">
            <div class="appmask" v-show="showSpin"></div>
        </transition>
        <pixel-spinner
                class="spin"
                v-show="showSpin"
                :animation-duration="2000"
                :size="30"
                color="#2d8cf0"
        />

        <router-view />
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {PixelSpinner} from 'epic-spinners'

    export default {
        computed: {
            ...mapState({
                showSpin: state => state.app.showSpin
            })
        },
        components: {
            PixelSpinner
        },
        mounted() {
            this.$nextTick(() => {
          
            })
        }
    }
</script>
<style lang="less">
    @import "./App.less";
</style>